var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgeCodeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_314_26",
    "data-name": "Component 314 \\u2013 26",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41130",
    "data-name": "Group 41130",
    transform: "translate(9718 8372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7999",
    "data-name": "Rectangle 7999",
    width: 148,
    height: 148,
    transform: "translate(-9662 -8372)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42210",
    "data-name": "Path 42210",
    d: "M450.089,43.8V94.563H445.5V43.8Z",
    transform: "translate(-10007.6 -8350.975)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42211",
    "data-name": "Path 42211",
    d: "M440.836,76.359v18.2H436.1V43.8h4.736v32.56Z",
    transform: "translate(-10012.111 -8350.975)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42212",
    "data-name": "Path 42212",
    d: "M430.089,61.9a4.588,4.588,0,1,1-4.589,4.588,4.588,4.588,0,0,1,4.589-4.588",
    transform: "translate(-10017.199 -8342.287)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42213",
    "data-name": "Path 42213",
    d: "M407.712,24.4a2.809,2.809,0,0,1,2.811,2.812,2.72,2.72,0,0,1-2.811,2.812,2.81,2.81,0,0,1-2.812-2.812,2.72,2.72,0,0,1,2.812-2.812",
    transform: "translate(-10027.087 -8360.287)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42214",
    "data-name": "Path 42214",
    d: "M454.332,26.9A1.332,1.332,0,1,1,453,28.231a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10003.999 -8359.087)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42215",
    "data-name": "Path 42215",
    d: "M445.032,21.3a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-10008.463 -8361.775)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42216",
    "data-name": "Path 42216",
    d: "M430.632,46.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-10015.375 -8349.487)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42217",
    "data-name": "Path 42217",
    d: "M423.732,67.5a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-10018.687 -8339.599)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42218",
    "data-name": "Path 42218",
    d: "M421.832,21.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10019.599 -8361.487)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42219",
    "data-name": "Path 42219",
    d: "M418.732,50a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,418.732,50",
    transform: "translate(-10021.087 -8347.999)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42220",
    "data-name": "Path 42220",
    d: "M404.332,30.7A1.332,1.332,0,1,1,403,32.032a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.999 -8357.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42221",
    "data-name": "Path 42221",
    d: "M404.332,71.3A1.332,1.332,0,1,1,403,72.631a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.999 -8337.775)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42222",
    "data-name": "Path 42222",
    d: "M403.132,49.4a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-10028.574 -8348.287)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42223",
    "data-name": "Path 42223",
    d: "M448.827,45.324a.922.922,0,0,1-.888-.592L439.5,24.6l-8.435,20.128a.894.894,0,1,1-1.628-.74l9.323-22.2a.963.963,0,0,1,1.777,0l9.323,22.2a.93.93,0,0,1-.443,1.184,1.121,1.121,0,0,1-.592.148",
    transform: "translate(-10015.366 -8361.822)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42224",
    "data-name": "Path 42224",
    d: "M436.389,95.887A.956.956,0,0,1,435.5,95V44.087a.889.889,0,0,1,1.778,0V95c.148.444-.3.888-.888.888",
    transform: "translate(-10012.399 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42225",
    "data-name": "Path 42225",
    d: "M448.889,95.887A.956.956,0,0,1,448,95V44.087a.889.889,0,0,1,1.778,0V95c.148.444-.3.888-.888.888",
    transform: "translate(-10006.399 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42226",
    "data-name": "Path 42226",
    d: "M439.589,95.887A.955.955,0,0,1,438.7,95V44.087a.889.889,0,0,1,1.777,0V95a.955.955,0,0,1-.888.888",
    transform: "translate(-10010.863 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42227",
    "data-name": "Path 42227",
    d: "M445.788,95.887A.954.954,0,0,1,444.9,95V44.087a.888.888,0,0,1,1.776,0V95a.954.954,0,0,1-.888.888",
    transform: "translate(-10007.887 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42228",
    "data-name": "Path 42228",
    d: "M484.688,48.287h-85.1a.954.954,0,0,1-.888-.888V37.187a.956.956,0,0,1,.888-.888h85.1a.956.956,0,0,1,.888.888V47.4a.954.954,0,0,1-.888.888m-84.212-1.923H483.8V38.076H400.476Z",
    transform: "translate(-10030.063 -8354.575)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42229",
    "data-name": "Path 42229",
    d: "M402.806,45.308a.922.922,0,0,1-.888-.592.934.934,0,0,1,.443-1.184l50.026-22.2a.7.7,0,0,1,.888.148l30.34,22.2a.947.947,0,0,1-1.182,1.48l-29.751-21.9-49.429,21.9a.55.55,0,0,1-.445.148",
    transform: "translate(-10028.545 -8361.806)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42230",
    "data-name": "Path 42230",
    d: "M439.784,95.947a.89.89,0,0,1-.592-.148.937.937,0,0,1-.148-1.332l8.436-10.212L438.9,77.447a1.073,1.073,0,0,1,0-1.48l8.288-6.66-8.288-6.66a1.073,1.073,0,0,1,0-1.48l8.584-8.584-8.436-7.844a.942.942,0,0,1,1.332-1.332l9.028,8.584a1.122,1.122,0,0,1,.3.592c0,.3-.148.444-.3.74l-8.584,8.584,8.436,6.808a1.073,1.073,0,0,1,0,1.48l-8.288,6.66,8.288,6.66a1.122,1.122,0,0,1,.3.592,1.334,1.334,0,0,1-.148.74L440.376,95.8c-.148,0-.3.148-.592.148",
    transform: "translate(-10010.911 -8351.323)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42231",
    "data-name": "Path 42231",
    d: "M405.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.554,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10027.327 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42232",
    "data-name": "Path 42232",
    d: "M410.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10024.927 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42233",
    "data-name": "Path 42233",
    d: "M415.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10022.527 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42234",
    "data-name": "Path 42234",
    d: "M420.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,1,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10020.127 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42235",
    "data-name": "Path 42235",
    d: "M425.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10017.728 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42236",
    "data-name": "Path 42236",
    d: "M430.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.554,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10015.327 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42237",
    "data-name": "Path 42237",
    d: "M435.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10012.927 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42238",
    "data-name": "Path 42238",
    d: "M440.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10010.527 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42239",
    "data-name": "Path 42239",
    d: "M445.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,1,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10008.127 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42240",
    "data-name": "Path 42240",
    d: "M450.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10005.728 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42241",
    "data-name": "Path 42241",
    d: "M484.688,79.375h-85.1a.888.888,0,1,1,0-1.776h85.1a.888.888,0,1,1,0,1.776",
    transform: "translate(-10030.063 -8334.751)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42242",
    "data-name": "Path 42242",
    d: "M484.688,41.875h-85.1a.888.888,0,1,1,0-1.776h85.1a.888.888,0,1,1,0,1.776",
    transform: "translate(-10030.063 -8352.751)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42243",
    "data-name": "Path 42243",
    d: "M414.824,81.975a5.6,5.6,0,0,1-1.034-11.1V44.087a.887.887,0,1,1,1.774,0V71.911a.956.956,0,0,1-.888.888,3.7,3.7,0,1,0,3.7,3.7.888.888,0,0,1,1.776,0,5.162,5.162,0,0,1-5.328,5.476",
    transform: "translate(-10025.023 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42244",
    "data-name": "Path 42244",
    d: "M415.788,61.875h-3.7a.888.888,0,1,1,0-1.776h3.7a.888.888,0,1,1,0,1.776",
    transform: "translate(-10024.063 -8343.151)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42245",
    "data-name": "Path 42245",
    d: "M415.788,59.375h-3.7a.888.888,0,1,1,0-1.776h3.7a.888.888,0,0,1,0,1.776",
    transform: "translate(-10024.063 -8344.351)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42246",
    "data-name": "Path 42246",
    d: "M413.288,73.675a.954.954,0,0,1-.888-.888v-3.7a.888.888,0,1,1,1.776,0v3.7a.954.954,0,0,1-.888.888",
    transform: "translate(-10023.487 -8339.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42247",
    "data-name": "Path 42247",
    d: "M430.424,72.448a5.624,5.624,0,1,1,5.624-5.624,5.621,5.621,0,0,1-5.624,5.624m0-9.324a3.7,3.7,0,1,0,3.7,3.7,3.664,3.664,0,0,0-3.7-3.7",
    transform: "translate(-10017.535 -8342.622)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42248",
    "data-name": "Path 42248",
    d: "M408,31.2a3.7,3.7,0,1,1,3.7-3.7,3.759,3.759,0,0,1-3.7,3.7m0-5.624a1.924,1.924,0,1,0,1.924,1.924A2.2,2.2,0,0,0,408,25.576",
    transform: "translate(-10027.375 -8360.574)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42249",
    "data-name": "Path 42249",
    d: "M452.089,92.911a.955.955,0,0,1-.889-.888V50.287a.889.889,0,0,1,1.777,0V91.875a.99.99,0,0,1-.888,1.036",
    transform: "translate(-10004.863 -8348.287)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42250",
    "data-name": "Path 42250",
    d: "M450.089,43.8V94.563H445.5V43.8Z",
    transform: "translate(-10007.6 -8350.975)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42251",
    "data-name": "Path 42251",
    d: "M440.836,76.359v18.2H436.1V43.8h4.736v32.56Z",
    transform: "translate(-10012.111 -8350.975)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42252",
    "data-name": "Path 42252",
    d: "M430.089,61.9a4.588,4.588,0,1,1-4.589,4.588,4.588,4.588,0,0,1,4.589-4.588",
    transform: "translate(-10017.199 -8342.287)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42253",
    "data-name": "Path 42253",
    d: "M407.712,24.4a2.809,2.809,0,0,1,2.811,2.812,2.72,2.72,0,0,1-2.811,2.812,2.81,2.81,0,0,1-2.812-2.812,2.72,2.72,0,0,1,2.812-2.812",
    transform: "translate(-10027.087 -8360.287)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42254",
    "data-name": "Path 42254",
    d: "M454.332,26.9A1.332,1.332,0,1,1,453,28.231a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10003.999 -8359.087)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42255",
    "data-name": "Path 42255",
    d: "M445.032,21.3a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-10008.463 -8361.775)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42256",
    "data-name": "Path 42256",
    d: "M430.632,46.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-10015.375 -8349.487)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42257",
    "data-name": "Path 42257",
    d: "M423.732,67.5a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-10018.687 -8339.599)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42258",
    "data-name": "Path 42258",
    d: "M421.832,21.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10019.599 -8361.487)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42259",
    "data-name": "Path 42259",
    d: "M418.732,50a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,418.732,50",
    transform: "translate(-10021.087 -8347.999)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42260",
    "data-name": "Path 42260",
    d: "M404.332,30.7A1.332,1.332,0,1,1,403,32.032a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.999 -8357.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42261",
    "data-name": "Path 42261",
    d: "M404.332,71.3A1.332,1.332,0,1,1,403,72.631a1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-10027.999 -8337.775)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42262",
    "data-name": "Path 42262",
    d: "M403.132,49.4a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-10028.574 -8348.287)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42263",
    "data-name": "Path 42263",
    d: "M448.827,45.324a.922.922,0,0,1-.888-.592L439.5,24.6l-8.435,20.128a.894.894,0,1,1-1.628-.74l9.323-22.2a.963.963,0,0,1,1.777,0l9.323,22.2a.93.93,0,0,1-.443,1.184,1.121,1.121,0,0,1-.592.148",
    transform: "translate(-10015.366 -8361.822)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42264",
    "data-name": "Path 42264",
    d: "M436.389,95.887A.956.956,0,0,1,435.5,95V44.087a.889.889,0,0,1,1.778,0V95c.148.444-.3.888-.888.888",
    transform: "translate(-10012.399 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42265",
    "data-name": "Path 42265",
    d: "M448.889,95.887A.956.956,0,0,1,448,95V44.087a.889.889,0,0,1,1.778,0V95c.148.444-.3.888-.888.888",
    transform: "translate(-10006.399 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42266",
    "data-name": "Path 42266",
    d: "M439.589,95.887A.955.955,0,0,1,438.7,95V44.087a.889.889,0,0,1,1.777,0V95a.955.955,0,0,1-.888.888",
    transform: "translate(-10010.863 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42267",
    "data-name": "Path 42267",
    d: "M445.788,95.887A.954.954,0,0,1,444.9,95V44.087a.888.888,0,0,1,1.776,0V95a.954.954,0,0,1-.888.888",
    transform: "translate(-10007.887 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42268",
    "data-name": "Path 42268",
    d: "M484.688,48.287h-85.1a.954.954,0,0,1-.888-.888V37.187a.956.956,0,0,1,.888-.888h85.1a.956.956,0,0,1,.888.888V47.4a.954.954,0,0,1-.888.888m-84.212-1.923H483.8V38.076H400.476Z",
    transform: "translate(-10030.063 -8354.575)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42269",
    "data-name": "Path 42269",
    d: "M402.806,45.308a.922.922,0,0,1-.888-.592.934.934,0,0,1,.443-1.184l50.026-22.2a.7.7,0,0,1,.888.148l30.34,22.2a.947.947,0,0,1-1.182,1.48l-29.751-21.9-49.429,21.9a.55.55,0,0,1-.445.148",
    transform: "translate(-10028.545 -8361.806)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42270",
    "data-name": "Path 42270",
    d: "M439.784,95.947a.89.89,0,0,1-.592-.148.937.937,0,0,1-.148-1.332l8.436-10.212L438.9,77.447a1.073,1.073,0,0,1,0-1.48l8.288-6.66-8.288-6.66a1.073,1.073,0,0,1,0-1.48l8.584-8.584-8.436-7.844a.942.942,0,0,1,1.332-1.332l9.028,8.584a1.122,1.122,0,0,1,.3.592c0,.3-.148.444-.3.74l-8.584,8.584,8.436,6.808a1.073,1.073,0,0,1,0,1.48l-8.288,6.66,8.288,6.66a1.122,1.122,0,0,1,.3.592,1.334,1.334,0,0,1-.148.74L440.376,95.8c-.148,0-.3.148-.592.148",
    transform: "translate(-10010.911 -8351.323)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42271",
    "data-name": "Path 42271",
    d: "M405.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.554,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10027.327 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42272",
    "data-name": "Path 42272",
    d: "M410.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10024.927 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42273",
    "data-name": "Path 42273",
    d: "M415.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10022.527 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42274",
    "data-name": "Path 42274",
    d: "M420.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,1,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10020.127 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42275",
    "data-name": "Path 42275",
    d: "M425.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10017.728 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42276",
    "data-name": "Path 42276",
    d: "M430.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.554,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10015.327 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42277",
    "data-name": "Path 42277",
    d: "M435.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10012.927 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42278",
    "data-name": "Path 42278",
    d: "M440.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10010.527 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42279",
    "data-name": "Path 42279",
    d: "M445.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,1,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.034.888",
    transform: "translate(-10008.127 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42280",
    "data-name": "Path 42280",
    d: "M450.288,48.289a.954.954,0,0,1-.888-.888V42.813a.544.544,0,0,1,.148-.444l3.7-5.624a.965.965,0,0,1,1.628,1.036l-3.553,5.328V47.4a1.264,1.264,0,0,1-1.035.888",
    transform: "translate(-10005.728 -8354.577)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42281",
    "data-name": "Path 42281",
    d: "M484.688,79.375h-85.1a.888.888,0,1,1,0-1.776h85.1a.888.888,0,1,1,0,1.776",
    transform: "translate(-10030.063 -8334.751)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42282",
    "data-name": "Path 42282",
    d: "M484.688,41.875h-85.1a.888.888,0,1,1,0-1.776h85.1a.888.888,0,1,1,0,1.776",
    transform: "translate(-10030.063 -8352.751)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42283",
    "data-name": "Path 42283",
    d: "M414.824,81.975a5.6,5.6,0,0,1-1.034-11.1V44.087a.887.887,0,1,1,1.774,0V71.911a.956.956,0,0,1-.888.888,3.7,3.7,0,1,0,3.7,3.7.888.888,0,0,1,1.776,0,5.162,5.162,0,0,1-5.328,5.476",
    transform: "translate(-10025.023 -8351.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42284",
    "data-name": "Path 42284",
    d: "M415.788,61.875h-3.7a.888.888,0,1,1,0-1.776h3.7a.888.888,0,1,1,0,1.776",
    transform: "translate(-10024.063 -8343.151)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42285",
    "data-name": "Path 42285",
    d: "M415.788,59.375h-3.7a.888.888,0,1,1,0-1.776h3.7a.888.888,0,0,1,0,1.776",
    transform: "translate(-10024.063 -8344.351)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42286",
    "data-name": "Path 42286",
    d: "M413.288,73.675a.954.954,0,0,1-.888-.888v-3.7a.888.888,0,1,1,1.776,0v3.7a.954.954,0,0,1-.888.888",
    transform: "translate(-10023.487 -8339.263)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42287",
    "data-name": "Path 42287",
    d: "M430.424,72.448a5.624,5.624,0,1,1,5.624-5.624,5.621,5.621,0,0,1-5.624,5.624m0-9.324a3.7,3.7,0,1,0,3.7,3.7,3.664,3.664,0,0,0-3.7-3.7",
    transform: "translate(-10017.535 -8342.622)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42288",
    "data-name": "Path 42288",
    d: "M408,31.2a3.7,3.7,0,1,1,3.7-3.7,3.759,3.759,0,0,1-3.7,3.7m0-5.624a1.924,1.924,0,1,0,1.924,1.924A2.2,2.2,0,0,0,408,25.576",
    transform: "translate(-10027.375 -8360.574)",
    fill: "#104452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42289",
    "data-name": "Path 42289",
    d: "M452.089,92.911a.955.955,0,0,1-.889-.888V50.287a.889.889,0,0,1,1.777,0V91.875a.99.99,0,0,1-.888,1.036",
    transform: "translate(-10004.863 -8348.287)",
    fill: "#104452"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeCodeDark);
export default __webpack_public_path__ + "static/media/bridge_code_dark.c2826a224bbf7e2f15da3c3cef193f0d.svg";
export { ForwardRef as ReactComponent };